import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useScopes from '../../utils/useScopes';
import useForm from '@afosto/utils-react/validation/useForm';
import useRegisterInput from '@afosto/app-components-react/Form/useRegisterInput';
import useIntl from '@afosto/utils-react/intl/useIntl';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import TextField from '@afosto/app-components-react/TextField';
import Form from '@afosto/app-components-react/Form';
import ScopesTree from '../ScopesTree';
import ScopesAutocomplete from '../ScopesAutocomplete';
import validationSchema from './validations';
import translations from './translations';

const RoleForm = ({ role, inline, onSubmit, onCancel }) => {
  const { name = '', scopes = [] } = role || {};
  const intl = useIntl();
  const [availableScopes] = useScopes();
  const formattedScopes = scopes.map(scope => ({
    label: scope,
    description:
      (availableScopes &&
        availableScopes.some(availableScope => availableScope.label === scope) &&
        availableScopes.find(availableScope => availableScope.label === scope).description) ||
      '',
  }));
  const form = useForm({
    validationSchema,
    editInline: inline,
    defaultValues: {
      name,
      scopes: formattedScopes,
    },
    onCancel,
    onSubmit,
  });
  useRegisterInput('scopes', true, form);
  const { setIsEditing, setValue } = form;

  useEffect(() => {
    if (inline) {
      setIsEditing(false);
    }
  }, [role, inline, setIsEditing]);

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="name"
          label={intl.formatMessage(translations.fields.name.label)}
          readOnly={form.editInline}
          autoFocus
        />
        {!form.editInline ? (
          <ScopesTree
            onChange={values =>
              setValue(
                'scopes',
                values.reduce((acc, scope) => [...acc, { label: scope, value: scope }], []),
              )
            }
            value={scopes}
            label={intl.formatMessage(translations.fields.scopes.label)}
            readOnly={form.editInline}
          />
        ) : (
          <ScopesAutocomplete
            name="scopes"
            label={intl.formatMessage(translations.fields.scopes.label)}
            options={availableScopes}
            readOnly={form.editInline}
          />
        )}
      </Form>
    </LoadingWrapper>
  );
};

RoleForm.propTypes = {
  role: PropTypes.object,
  inline: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

RoleForm.defaultProps = {
  role: null,
  inline: false,
  onSubmit: undefined,
  onCancel: undefined,
};

export default RoleForm;
